import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useCart } from "../context/CartContext";

export const ProductCard = ({ product, large = false }) => {
  const { addItem, setDrawerOpen } = useCart();
  const quickAdd = (e) => {
    e.preventDefault();
    addItem(product, product.sizes?.[0] || "ONE SIZE", 1, product.colors?.[0] || null);
    setDrawerOpen(true);
  };

  return (
    <motion.div
      whileHover={{ y: -4 }}
      transition={{ duration: 0.25 }}
      className="group relative bg-[#1E1A17] border border-[#2C2623] hover:border-[#E05A36]/60 transition-colors h-full"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`} className="block h-full" data-testid={`product-link-${product.id}`}>
        <div className={`relative overflow-hidden ${large ? "aspect-[4/5]" : "aspect-[3/4]"}`}>
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover transition-all duration-700 group-hover:scale-105 group-hover:opacity-0"
          />
          <img
            src={product.image_alt || product.image}
            alt={`${product.name} alternate`}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover opacity-0 scale-105 transition-all duration-700 group-hover:opacity-100 group-hover:scale-100"
          />
          {product.tag && (
            <span className="absolute top-3 left-3 inline-flex items-center px-2.5 py-1 text-[10px] font-mono font-bold uppercase bg-[#E05A36]/90 text-[#0C0A09]" data-testid={`product-tag-${product.id}`}>
              {product.tag}
            </span>
          )}
          {!product.in_stock && (
            <span className="absolute top-3 right-3 px-2.5 py-1 text-[10px] font-mono font-bold uppercase bg-[#0C0A09]/90 text-[#7A7067] border border-[#2C2623]">
              Sold out
            </span>
          )}
          {product.in_stock && (
            <button
              onClick={quickAdd}
              className="absolute bottom-3 right-3 bg-[#E05A36] text-[#0C0A09] p-2.5 opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 hover:bg-[#F06B47]"
              data-testid={`product-quick-add-${product.id}`}
              aria-label="Quick add to cart"
            >
              <Plus className="w-4 h-4" />
            </button>
          )}
        </div>
        <div className="p-4">
          <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-[#7A7067] mb-1">{product.category}</p>
          <h3 className="font-display font-bold tracking-tight text-sm sm:text-base leading-tight mb-2">{product.name}</h3>
          <div className="flex items-baseline gap-2">
            <span className="font-mono text-[#E29D47] font-medium" data-testid={`product-price-${product.id}`}>${product.price.toFixed(2)}</span>
            {product.original_price > product.price && (
              <span className="font-mono text-xs text-[#7A7067] line-through">${product.original_price.toFixed(2)}</span>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
